import { render, staticRenderFns } from "./companyinfo.vue?vue&type=template&id=3e347ab7&scoped=true&"
import script from "./companyinfo.vue?vue&type=script&lang=js&"
export * from "./companyinfo.vue?vue&type=script&lang=js&"
import style0 from "./companyinfo.vue?vue&type=style&index=0&id=3e347ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e347ab7",
  null
  
)

export default component.exports